import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

import extraReducers from "./extraReducers";

const initialState = {
  localizationId: "",
  city: "",
  timezone: "Europe/Warsaw",
  pickedLanguage: "",
};

const appConfigSlice = createSlice({
  name: "appConfig",
  initialState,
  extraReducers: extraReducers(initialState),
  reducers: {
    setAppConfig: (state, { payload }: PayloadAction<Partial<typeof initialState>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setAppConfig } = appConfigSlice.actions;

export default appConfigSlice.reducer;
